var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-sm-12", on: { dblclick: _vm.toggleEditMode } },
    [
      _c(
        "div",
        { staticClass: "list-group scoped-custom-list-group" },
        _vm._l(_vm.currentSettingsTab, function(advancedSetting) {
          return _c(
            "div",
            {
              key: advancedSetting.name,
              staticClass:
                "list-group-item question-option-advanced-setting-block"
            },
            [
              _c(
                "pre",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$store.debugMode === true,
                      expression: "$store.debugMode === true"
                    }
                  ]
                },
                [_vm._v(_vm._s(advancedSetting))]
              ),
              _c(_vm.getComponentName(advancedSetting.inputtype), {
                tag: "component",
                attrs: {
                  elId: advancedSetting.formElementId,
                  elName: advancedSetting.formElementName,
                  elLabel: advancedSetting.title,
                  elHelp: advancedSetting.formElementHelp,
                  currentValue: _vm.currentValue(advancedSetting),
                  elOptions: advancedSetting.aFormElementOptions,
                  debug: advancedSetting,
                  readonly: _vm.isReadonly(advancedSetting)
                },
                on: {
                  change: function($event) {
                    return _vm.reactOnChange($event, advancedSetting)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }